import React, { ReactElement } from 'react';
import { SpinnerContainer, StyledSpinner } from './Spinner.styled';
import { ComponentProps as Props } from './Spinner.types';

const Spinner: React.FC<Props> = ({ mode, size }): ReactElement<Props> => {
  return (
    <SpinnerContainer>
      <StyledSpinner mode={mode} size={size} />
    </SpinnerContainer>
  );
};

export default Spinner;
